import { PATHS } from '../../constants';

import { Instruction } from './Instruction';

const InstructionPreviewRoute = {
  path: PATHS.Preview.Instruction,
  element: <Instruction />,
};

export default InstructionPreviewRoute;
